<agr-form-dialog [formGroup]="formGroup" [data]="data" (confirm)="confirm()" (cancel)="cancel()" class="flex--gutter-container">
  <!-- CropVarietyName select box -->
  <div class="flex--row flex--gutter first-field">
    <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
      <mat-label>{{ 'tgaVarieties.cropVarietyName' | translate }}</mat-label>
      <input
        type="text"
        matInput
        formControlName="cropVarietySelection"
        [matAutocomplete]="cropVarietyAutocomplete"
        data-test="create-variety-property-crop-variety-name"
      />
      <mat-autocomplete #cropVarietyAutocomplete="matAutocomplete" [displayWith]="displayCropVariety()">
        @for (cropVariety of filteredCropVarieties$ | async; track cropVariety.ediCode) {
          <mat-option [value]="cropVariety.ediCode" [disabled]="isEditMode">
            {{ cropVariety.name }}
          </mat-option>
        }
      </mat-autocomplete>
      @if (formGroup.controls.cropVarietySelection.hasError('required')) {
        <mat-error> {{ 'tgaVarieties.cropVarietyName' | translate }} is required </mat-error>
      }
    </mat-form-field>
  </div>

  <!-- Knol Zetting input -->
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
      <mat-label>{{ 'tgaVarieties.knolZetting' | translate }}</mat-label>
      <input matInput type="number" formControlName="knolZetting" min="1" max="10" data-test="variety-property-knol-zetting" />
      @if (formGroup.controls.knolZetting.hasError('min') || formGroup.controls.knolZetting.hasError('max')) {
        <mat-error> {{ 'tgaVarieties.knolZetting' | translate }} must be between 1 and 10 </mat-error>
      }
      @if (formGroup.controls.knolZetting.hasError('serverError')) {
        <mat-error>
          {{ formGroup.controls.knolZetting.getError('serverError') }}
        </mat-error>
      }
    </mat-form-field>
  </div>

  <!-- Vroegheid Ras input -->
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
      <mat-label>{{ 'tgaVarieties.vroegheidRas' | translate }}</mat-label>
      <input matInput type="number" formControlName="vroegheidRas" min="1" max="10" data-test="variety-property-vroegheid-ras" />
      @if (formGroup.controls.vroegheidRas.hasError('min') || formGroup.controls.vroegheidRas.hasError('max')) {
        <mat-error> {{ 'tgaVarieties.vroegheidRas' | translate }} must be between 1 and 10 </mat-error>
      }
      @if (formGroup.controls.vroegheidRas.hasError('serverError')) {
        <mat-error>
          {{ formGroup.controls.vroegheidRas.getError('serverError') }}
        </mat-error>
      }
    </mat-form-field>
  </div>

  <!-- Ras Score Phytophthora input -->
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
      <mat-label>{{ 'tgaVarieties.rasScorePhytophthora' | translate }}</mat-label>
      <input matInput type="number" formControlName="rasScorePhytophthora" min="1" max="10" data-test="variety-property-ras-score-phytophthora" />
      @if (formGroup.controls.rasScorePhytophthora.hasError('min') || formGroup.controls.rasScorePhytophthora.hasError('max')) {
        <mat-error> {{ 'tgaVarieties.rasScorePhytophthora' | translate }} must be between 1 and 10 </mat-error>
      }
      @if (formGroup.controls.rasScorePhytophthora.hasError('serverError')) {
        <mat-error>
          {{ formGroup.controls.rasScorePhytophthora.getError('serverError') }}
        </mat-error>
      }
    </mat-form-field>
  </div>

  <!-- Ras Score Schurft input -->
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
      <mat-label>{{ 'tgaVarieties.rasScoreSchurft' | translate }}</mat-label>
      <input matInput type="number" formControlName="rasScoreSchurft" min="1" max="10" data-test="variety-property-ras-score-schurft" />
      @if (formGroup.controls.rasScoreSchurft.hasError('min') || formGroup.controls.rasScoreSchurft.hasError('max')) {
        <mat-error> {{ 'tgaVarieties.rasScoreSchurft' | translate }} must be between 1 and 10 </mat-error>
      }
      @if (formGroup.controls.rasScoreSchurft.hasError('serverError')) {
        <mat-error>
          {{ formGroup.controls.rasScoreSchurft.getError('serverError') }}
        </mat-error>
      }
    </mat-form-field>
  </div>

  <!-- Ras Score Zwarte Spikkel input -->
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
      <mat-label>{{ 'tgaVarieties.rasScoreZwarteSpikkel' | translate }}</mat-label>
      <input matInput type="number" formControlName="rasScoreZwarteSpikkel" min="1" max="10" data-test="variety-property-ras-score-zwarte-spikkel" />
      @if (formGroup.controls.rasScoreZwarteSpikkel.hasError('min') || formGroup.controls.rasScoreZwarteSpikkel.hasError('max')) {
        <mat-error> {{ 'tgaVarieties.rasScoreZwarteSpikkel' | translate }} must be between 1 and 10 </mat-error>
      }
      @if (formGroup.controls.rasScoreZwarteSpikkel.hasError('serverError')) {
        <mat-error>
          {{ formGroup.controls.rasScoreZwarteSpikkel.getError('serverError') }}
        </mat-error>
      }
    </mat-form-field>
  </div>

  <!-- Trading Company input -->
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
      <mat-label>{{ 'tgaVarieties.tradingCompany' | translate }}</mat-label>
      <input matInput type="text" formControlName="tradingCompany" data-test="variety-property-trading-company" />
      @if (formGroup.controls.tradingCompany.hasError('serverError')) {
        <mat-error>
          {{ formGroup.controls.tradingCompany.getError('serverError') }}
        </mat-error>
      }
    </mat-form-field>
  </div>

  <!-- NVWA Globodera Ros14 Score input -->
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
      <mat-label>{{ 'tgaVarieties.nvwaGloboderaRos14Score' | translate }}</mat-label>
      <input matInput type="number" formControlName="nvwaGloboderaRos14Score" min="0" max="10" data-test="variety-property-nvwa-globodera-ros14-score" />
      @if (formGroup.controls.nvwaGloboderaRos14Score.hasError('min') || formGroup.controls.nvwaGloboderaRos14Score.hasError('max')) {
        <mat-error> {{ 'tgaVarieties.nvwaGloboderaRos14Score' | translate }} must be between 0 and 10 </mat-error>
      }
      @if (formGroup.controls.nvwaGloboderaRos14Score.hasError('serverError')) {
        <mat-error>
          {{ formGroup.controls.nvwaGloboderaRos14Score.getError('serverError') }}
        </mat-error>
      }
    </mat-form-field>
  </div>

  <!-- Trading Globodera Ros14 Score input -->
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
      <mat-label>{{ 'tgaVarieties.tradingGloboderaRos14Score' | translate }}</mat-label>
      <input matInput type="number" formControlName="tradingGloboderaRos14Score" min="0" max="10" data-test="variety-property-trading-globodera-ros14-score" />
      @if (formGroup.controls.tradingGloboderaRos14Score.hasError('min') || formGroup.controls.tradingGloboderaRos14Score.hasError('max')) {
        <mat-error> {{ 'tgaVarieties.tradingGloboderaRos14Score' | translate }} must be between 0 and 10 </mat-error>
      }
      @if (formGroup.controls.tradingGloboderaRos14Score.hasError('serverError')) {
        <mat-error>
          {{ formGroup.controls.tradingGloboderaRos14Score.getError('serverError') }}
        </mat-error>
      }
    </mat-form-field>
  </div>

  <!-- NVWA Globodera Ros14 Rv input -->
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
      <mat-label>{{ 'tgaVarieties.nvwaGloboderaRos14Rv' | translate }}</mat-label>
      <input matInput type="number" formControlName="nvwaGloboderaRos14Rv" min="0" max="100" data-test="variety-property-nvwa-globodera-ros14-rv" />
      @if (formGroup.controls.nvwaGloboderaRos14Rv.hasError('min') || formGroup.controls.nvwaGloboderaRos14Rv.hasError('max')) {
        <mat-error> {{ 'tgaVarieties.nvwaGloboderaRos14Rv' | translate }} must be between 0 and 100 </mat-error>
      }
      @if (formGroup.controls.nvwaGloboderaRos14Rv.hasError('serverError')) {
        <mat-error>
          {{ formGroup.controls.nvwaGloboderaRos14Rv.getError('serverError') }}
        </mat-error>
      }
    </mat-form-field>
  </div>

  <!-- NVWA Globodera Ros23 Score input -->
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
      <mat-label>{{ 'tgaVarieties.nvwaGloboderaRos23Score' | translate }}</mat-label>
      <input matInput type="number" formControlName="nvwaGloboderaRos23Score" min="0" max="10" data-test="variety-property-nvwa-globodera-ros23-score" />
      @if (formGroup.controls.nvwaGloboderaRos23Score.hasError('min') || formGroup.controls.nvwaGloboderaRos23Score.hasError('max')) {
        <mat-error> {{ 'tgaVarieties.nvwaGloboderaRos23Score' | translate }} must be between 0 and 10 </mat-error>
      }
      @if (formGroup.controls.nvwaGloboderaRos23Score.hasError('serverError')) {
        <mat-error>
          {{ formGroup.controls.nvwaGloboderaRos23Score.getError('serverError') }}
        </mat-error>
      }
    </mat-form-field>
  </div>

  <!-- Trading Globodera Ros23 Score input -->
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
      <mat-label>{{ 'tgaVarieties.tradingGloboderaRos23Score' | translate }}</mat-label>
      <input matInput type="number" formControlName="tradingGloboderaRos23Score" min="0" max="10" data-test="variety-property-trading-globodera-ros23-score" />
      @if (formGroup.controls.tradingGloboderaRos23Score.hasError('min') || formGroup.controls.tradingGloboderaRos23Score.hasError('max')) {
        <mat-error> {{ 'tgaVarieties.tradingGloboderaRos23Score' | translate }} must be between 0 and 10 </mat-error>
      }
      @if (formGroup.controls.tradingGloboderaRos23Score.hasError('serverError')) {
        <mat-error>
          {{ formGroup.controls.tradingGloboderaRos23Score.getError('serverError') }}
        </mat-error>
      }
    </mat-form-field>
  </div>

  <!-- NVWA Globodera Ros23 Rv input -->
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
      <mat-label>{{ 'tgaVarieties.nvwaGloboderaRos23Rv' | translate }}</mat-label>
      <input matInput type="number" formControlName="nvwaGloboderaRos23Rv" min="0" max="100" data-test="variety-property-nvwa-globodera-ros23-rv" />
      @if (formGroup.controls.nvwaGloboderaRos23Rv.hasError('min') || formGroup.controls.nvwaGloboderaRos23Rv.hasError('max')) {
        <mat-error> {{ 'tgaVarieties.nvwaGloboderaRos23Rv' | translate }} must be between 0 and 100 </mat-error>
      }
      @if (formGroup.controls.nvwaGloboderaRos23Rv.hasError('serverError')) {
        <mat-error>
          {{ formGroup.controls.nvwaGloboderaRos23Rv.getError('serverError') }}
        </mat-error>
      }
    </mat-form-field>
  </div>

  <!-- NVWA Globodera Pal2 Score input -->
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
      <mat-label>{{ 'tgaVarieties.nvwaGloboderaPal2Score' | translate }}</mat-label>
      <input matInput type="number" formControlName="nvwaGloboderaPal2Score" min="0" max="10" data-test="variety-property-nvwa-globodera-pal2-score" />
      @if (formGroup.controls.nvwaGloboderaPal2Score.hasError('min') || formGroup.controls.nvwaGloboderaPal2Score.hasError('max')) {
        <mat-error> {{ 'tgaVarieties.nvwaGloboderaPal2Score' | translate }} must be between 0 and 10 </mat-error>
      }
      @if (formGroup.controls.nvwaGloboderaPal2Score.hasError('serverError')) {
        <mat-error>
          {{ formGroup.controls.nvwaGloboderaPal2Score.getError('serverError') }}
        </mat-error>
      }
    </mat-form-field>
  </div>

  <!-- Trading Globodera Pal2 Score input -->
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
      <mat-label>{{ 'tgaVarieties.tradingGloboderaPal2Score' | translate }}</mat-label>
      <input matInput type="number" formControlName="tradingGloboderaPal2Score" min="0" max="10" data-test="variety-property-trading-globodera-pal2-score" />
      @if (formGroup.controls.tradingGloboderaPal2Score.hasError('min') || formGroup.controls.tradingGloboderaPal2Score.hasError('max')) {
        <mat-error> {{ 'tgaVarieties.tradingGloboderaPal2Score' | translate }} must be between 0 and 10 </mat-error>
      }
      @if (formGroup.controls.tradingGloboderaPal2Score.hasError('serverError')) {
        <mat-error>
          {{ formGroup.controls.tradingGloboderaPal2Score.getError('serverError') }}
        </mat-error>
      }
    </mat-form-field>
  </div>

  <!-- NVWA Globodera Pal2 Rv input -->
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
      <mat-label>{{ 'tgaVarieties.nvwaGloboderaPal2Rv' | translate }}</mat-label>
      <input matInput type="number" formControlName="nvwaGloboderaPal2Rv" min="0" max="100" data-test="variety-property-nvwa-globodera-pal2-rv" />
      @if (formGroup.controls.nvwaGloboderaPal2Rv.hasError('min') || formGroup.controls.nvwaGloboderaPal2Rv.hasError('max')) {
        <mat-error> {{ 'tgaVarieties.nvwaGloboderaPal2Rv' | translate }} must be between 0 and 100 </mat-error>
      }
      @if (formGroup.controls.nvwaGloboderaPal2Rv.hasError('serverError')) {
        <mat-error>
          {{ formGroup.controls.nvwaGloboderaPal2Rv.getError('serverError') }}
        </mat-error>
      }
    </mat-form-field>
  </div>

  <!-- NVWA Globodera Pal3 Score input -->
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
      <mat-label>{{ 'tgaVarieties.nvwaGloboderaPal3Score' | translate }}</mat-label>
      <input matInput type="number" formControlName="nvwaGloboderaPal3Score" min="0" max="10" data-test="variety-property-nvwa-globodera-pal3-score" />
      @if (formGroup.controls.nvwaGloboderaPal3Score.hasError('min') || formGroup.controls.nvwaGloboderaPal3Score.hasError('max')) {
        <mat-error> {{ 'tgaVarieties.nvwaGloboderaPal3Score' | translate }} must be between 0 and 10 </mat-error>
      }
      @if (formGroup.controls.nvwaGloboderaPal3Score.hasError('serverError')) {
        <mat-error>
          {{ formGroup.controls.nvwaGloboderaPal3Score.getError('serverError') }}
        </mat-error>
      }
    </mat-form-field>
  </div>

  <!-- Trading Globodera Pal3 Score input -->
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
      <mat-label>{{ 'tgaVarieties.tradingGloboderaPal3Score' | translate }}</mat-label>
      <input matInput type="number" formControlName="tradingGloboderaPal3Score" min="0" max="10" data-test="variety-property-trading-globodera-pal3-score" />
      @if (formGroup.controls.tradingGloboderaPal3Score.hasError('min') || formGroup.controls.tradingGloboderaPal3Score.hasError('max')) {
        <mat-error> {{ 'tgaVarieties.tradingGloboderaPal3Score' | translate }} must be between 0 and 10 </mat-error>
      }
      @if (formGroup.controls.tradingGloboderaPal3Score.hasError('serverError')) {
        <mat-error>
          {{ formGroup.controls.tradingGloboderaPal3Score.getError('serverError') }}
        </mat-error>
      }
    </mat-form-field>
  </div>

  <!-- NVWA Globodera Pal3 Rv input -->
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
      <mat-label>{{ 'tgaVarieties.nvwaGloboderaPal3Rv' | translate }}</mat-label>
      <input matInput type="number" formControlName="nvwaGloboderaPal3Rv" min="0" max="100" data-test="variety-property-nvwa-globodera-pal3-rv" />
      @if (formGroup.controls.nvwaGloboderaPal3Rv.hasError('min') || formGroup.controls.nvwaGloboderaPal3Rv.hasError('max')) {
        <mat-error> {{ 'tgaVarieties.nvwaGloboderaPal3Rv' | translate }} must be between 0 and 100 </mat-error>
      }
      @if (formGroup.controls.nvwaGloboderaPal3Rv.hasError('serverError')) {
        <mat-error>
          {{ formGroup.controls.nvwaGloboderaPal3Rv.getError('serverError') }}
        </mat-error>
      }
    </mat-form-field>
  </div>

  <!-- NVWA Globodera Ros5 Score input -->
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
      <mat-label>{{ 'tgaVarieties.nvwaGloboderaRos5Score' | translate }}</mat-label>
      <input matInput type="number" formControlName="nvwaGloboderaRos5Score" min="0" max="10" data-test="variety-property-nvwa-globodera-ros5-score" />
      @if (formGroup.controls.nvwaGloboderaRos5Score.hasError('min') || formGroup.controls.nvwaGloboderaRos5Score.hasError('max')) {
        <mat-error> {{ 'tgaVarieties.nvwaGloboderaRos5Score' | translate }} must be between 0 and 10 </mat-error>
      }
      @if (formGroup.controls.nvwaGloboderaRos5Score.hasError('serverError')) {
        <mat-error>
          {{ formGroup.controls.nvwaGloboderaRos5Score.getError('serverError') }}
        </mat-error>
      }
    </mat-form-field>
  </div>

  <!-- Trading Globodera Ros5 Score input -->
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
      <mat-label>{{ 'tgaVarieties.tradingGloboderaRos5Score' | translate }}</mat-label>
      <input matInput type="number" formControlName="tradingGloboderaRos5Score" min="0" max="10" data-test="variety-property-trading-globodera-ros5-score" />
      @if (formGroup.controls.tradingGloboderaRos5Score.hasError('min') || formGroup.controls.tradingGloboderaRos5Score.hasError('max')) {
        <mat-error> {{ 'tgaVarieties.tradingGloboderaRos5Score' | translate }} must be between 0 and 10 </mat-error>
      }
      @if (formGroup.controls.tradingGloboderaRos5Score.hasError('serverError')) {
        <mat-error>
          {{ formGroup.controls.tradingGloboderaRos5Score.getError('serverError') }}
        </mat-error>
      }
    </mat-form-field>
  </div>

  <!-- NVWA Globodera Ros5 Rv input -->
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
      <mat-label>{{ 'tgaVarieties.nvwaGloboderaRos5Rv' | translate }}</mat-label>
      <input matInput type="number" formControlName="nvwaGloboderaRos5Rv" min="0" max="100" data-test="variety-property-nvwa-globodera-ros5-rv" />
      @if (formGroup.controls.nvwaGloboderaRos5Rv.hasError('min') || formGroup.controls.nvwaGloboderaRos5Rv.hasError('max')) {
        <mat-error> {{ 'tgaVarieties.nvwaGloboderaRos5Rv' | translate }} must be between 0 and 100 </mat-error>
      }
      @if (formGroup.controls.nvwaGloboderaRos5Rv.hasError('serverError')) {
        <mat-error>
          {{ formGroup.controls.nvwaGloboderaRos5Rv.getError('serverError') }}
        </mat-error>
      }
    </mat-form-field>
  </div>

  <!-- Score Alternaria input -->
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
      <mat-label>{{ 'tgaVarieties.scoreAlternaria' | translate }}</mat-label>
      <input matInput type="number" formControlName="scoreAlternaria" min="0" max="10" data-test="variety-property-score-alternaria" />
      @if (formGroup.controls.scoreAlternaria.hasError('min') || formGroup.controls.scoreAlternaria.hasError('max')) {
        <mat-error> {{ 'tgaVarieties.scoreAlternaria' | translate }} must be between 0 and 10 </mat-error>
      }
      @if (formGroup.controls.scoreAlternaria.hasError('serverError')) {
        <mat-error>
          {{ formGroup.controls.scoreAlternaria.getError('serverError') }}
        </mat-error>
      }
    </mat-form-field>
  </div>

  <!-- Score Fusarium input -->
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
      <mat-label>{{ 'tgaVarieties.scoreFusarium' | translate }}</mat-label>
      <input matInput type="number" formControlName="scoreFusarium" min="0" max="10" data-test="variety-property-score-fusarium" />
      @if (formGroup.controls.scoreFusarium.hasError('min') || formGroup.controls.scoreFusarium.hasError('max')) {
        <mat-error> {{ 'tgaVarieties.scoreFusarium' | translate }} must be between 0 and 10 </mat-error>
      }
      @if (formGroup.controls.scoreFusarium.hasError('serverError')) {
        <mat-error>
          {{ formGroup.controls.scoreFusarium.getError('serverError') }}
        </mat-error>
      }
    </mat-form-field>
  </div>

  <!-- Score Phytophthora Tuber input -->
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
      <mat-label>{{ 'tgaVarieties.scorePhytophthoraTuber' | translate }}</mat-label>
      <input matInput type="number" formControlName="scorePhytophthoraTuber" min="0" max="10" data-test="variety-property-score-phytophthora-tuber" />
      @if (formGroup.controls.scorePhytophthoraTuber.hasError('min') || formGroup.controls.scorePhytophthoraTuber.hasError('max')) {
        <mat-error> {{ 'tgaVarieties.scorePhytophthoraTuber' | translate }} must be between 0 and 10 </mat-error>
      }
      @if (formGroup.controls.scorePhytophthoraTuber.hasError('serverError')) {
        <mat-error>
          {{ formGroup.controls.scorePhytophthoraTuber.getError('serverError') }}
        </mat-error>
      }
    </mat-form-field>
  </div>

  <!-- Score Leafroll Virus input -->
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
      <mat-label>{{ 'tgaVarieties.scoreLeafrollVirus' | translate }}</mat-label>
      <input matInput type="number" formControlName="scoreLeafrollVirus" min="0" max="10" data-test="variety-property-score-leafroll-virus" />
      @if (formGroup.controls.scoreLeafrollVirus.hasError('min') || formGroup.controls.scoreLeafrollVirus.hasError('max')) {
        <mat-error> {{ 'tgaVarieties.scoreLeafrollVirus' | translate }} must be between 0 and 10 </mat-error>
      }
      @if (formGroup.controls.scoreLeafrollVirus.hasError('serverError')) {
        <mat-error>
          {{ formGroup.controls.scoreLeafrollVirus.getError('serverError') }}
        </mat-error>
      }
    </mat-form-field>
  </div>

  <!-- Score Virus Yntn Tuber input -->
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
      <mat-label>{{ 'tgaVarieties.scoreVirusYntnTuber' | translate }}</mat-label>
      <input matInput type="number" formControlName="scoreVirusYntnTuber" min="0" max="10" data-test="variety-property-score-virus-yntn-tuber" />
      @if (formGroup.controls.scoreVirusYntnTuber.hasError('min') || formGroup.controls.scoreVirusYntnTuber.hasError('max')) {
        <mat-error> {{ 'tgaVarieties.scoreVirusYntnTuber' | translate }} must be between 0 and 10 </mat-error>
      }
      @if (formGroup.controls.scoreVirusYntnTuber.hasError('serverError')) {
        <mat-error>
          {{ formGroup.controls.scoreVirusYntnTuber.getError('serverError') }}
        </mat-error>
      }
    </mat-form-field>
  </div>

  <!-- NVWA Wart Disease F1 Score input -->
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
      <mat-label>{{ 'tgaVarieties.nvwaWartDiseaseF1Score' | translate }}</mat-label>
      <input matInput type="number" formControlName="nvwaWartDiseaseF1Score" min="0" max="10" data-test="variety-property-nvwa-wart-disease-f1-score" />
      @if (formGroup.controls.nvwaWartDiseaseF1Score.hasError('min') || formGroup.controls.nvwaWartDiseaseF1Score.hasError('max')) {
        <mat-error> {{ 'tgaVarieties.nvwaWartDiseaseF1Score' | translate }} must be between 0 and 10 </mat-error>
      }
      @if (formGroup.controls.nvwaWartDiseaseF1Score.hasError('serverError')) {
        <mat-error>
          {{ formGroup.controls.nvwaWartDiseaseF1Score.getError('serverError') }}
        </mat-error>
      }
    </mat-form-field>
  </div>

  <!-- NVWA Wart Disease F26 Score input -->
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
      <mat-label>{{ 'tgaVarieties.nvwaWartDiseaseF26Score' | translate }}</mat-label>
      <input matInput type="number" formControlName="nvwaWartDiseaseF26Score" min="0" max="10" data-test="variety-property-nvwa-wart-disease-f26-score" />
      @if (formGroup.controls.nvwaWartDiseaseF26Score.hasError('min') || formGroup.controls.nvwaWartDiseaseF26Score.hasError('max')) {
        <mat-error> {{ 'tgaVarieties.nvwaWartDiseaseF26Score' | translate }} must be between 0 and 10 </mat-error>
      }
      @if (formGroup.controls.nvwaWartDiseaseF26Score.hasError('serverError')) {
        <mat-error>
          {{ formGroup.controls.nvwaWartDiseaseF26Score.getError('serverError') }}
        </mat-error>
      }
    </mat-form-field>
  </div>

  <!-- NVWA Wart Disease F18 Score input -->
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
      <mat-label>{{ 'tgaVarieties.nvwaWartDiseaseF18Score' | translate }}</mat-label>
      <input matInput type="number" formControlName="nvwaWartDiseaseF18Score" min="0" max="10" data-test="variety-property-nvwa-wart-disease-f18-score" />
      @if (formGroup.controls.nvwaWartDiseaseF18Score.hasError('min') || formGroup.controls.nvwaWartDiseaseF18Score.hasError('max')) {
        <mat-error> {{ 'tgaVarieties.nvwaWartDiseaseF18Score' | translate }} must be between 0 and 10 </mat-error>
      }
      @if (formGroup.controls.nvwaWartDiseaseF18Score.hasError('serverError')) {
        <mat-error>
          {{ formGroup.controls.nvwaWartDiseaseF18Score.getError('serverError') }}
        </mat-error>
      }
    </mat-form-field>
  </div>

  <div class="flex--row flex--gutter">
    <div class="mat-slide-group-wrapper flex__child--auto">
      <div class="mat-slide-group mat-slide-group--match-form-field-size">
        <mat-slide-toggle color="primary" formControlName="wortellesieaaltjeTolerant" data-test="variety-property-wortellesieaaltjeTolerant">
          {{ 'tgaVarieties.wortellesieaaltjeTolerant' | translate }}
        </mat-slide-toggle>
      </div>
    </div>
  </div>
</agr-form-dialog>
